// src/lib/utils.ts
import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// tailwind.config.js sets Tailwind's (v3-style) `prefix: "tw-"`, which is
// concatenated directly onto the utility (e.g. "tw-h-9"), unlike
// tailwind-merge's built-in `prefix` option, which assumes a Tailwind v4-style
// prefix separated by a colon (e.g. "tw:h-9"). Strip it manually so
// conflicting utilities (e.g. "tw-h-9" vs "tw-h-[--cell-size]") still dedupe.
const PREFIX = "tw-"

const twMerge = extendTailwindMerge({
  experimentalParseClassName: ({ className, parseClassName }) => {
    const parsed = parseClassName(className)
    if (parsed.isExternal || !parsed.baseClassName.startsWith(PREFIX)) {
      return parsed
    }
    return {
      ...parsed,
      baseClassName: parsed.baseClassName.slice(PREFIX.length),
      maybePostfixModifierPosition:
        parsed.maybePostfixModifierPosition === undefined
          ? undefined
          : parsed.maybePostfixModifierPosition - PREFIX.length,
    }
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
